/*
 * "Seen once" for a free-week app's live screen (V6, screens/new/Live.tsx): remembered for good in
 * localStorage, and for this tab in sessionStorage. Seen before but not in this tab is a LATER visit,
 * which opens the offer to keep it live while the week runs (Live.tsx, FreeWeekNudge.tsx).
 */
const seenKey = (projectId: string): string => `saddle.liveSeen.${projectId}`;

/** Whether this project's live screen was seen on an earlier visit and not yet on this one. */
export function cameBackLater(projectId: string): boolean {
  try {
    return localStorage.getItem(seenKey(projectId)) !== null && sessionStorage.getItem(seenKey(projectId)) === null;
  } catch {
    return false;
  }
}

/** This visit has had its look (or its offer): not again until the next one. */
export function markSeenThisVisit(projectId: string): void {
  try {
    sessionStorage.setItem(seenKey(projectId), '1');
  } catch {
    /* nothing remembered: at worst the offer opens once more this visit */
  }
}

/** Remember that this project's live app has been seen, for good and for this visit. */
export function markSeen(projectId: string): void {
  try {
    localStorage.setItem(seenKey(projectId), '1');
  } catch {
    /* nothing remembered: a later visit is just a visit */
  }
  markSeenThisVisit(projectId);
}
